module.exports = __webpack_public_path__ + "static/media/1.e1dcacb9.png";